var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconerrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,22A11,11,0,0,1,3.222,3.222,11,11,0,1,1,18.778,18.778,10.928,10.928,0,0,1,11,22Zm0-10.274h0l3.988,3.988.725-.725L11.725,11l3.989-3.989-.725-.725L11,10.274,7.011,6.286l-.725.725L10.274,11,6.286,14.989l.725.725L11,11.726Z",
    transform: "translate(1 1.001)",
    fill: "#D60D4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconerrorCircle);
export default __webpack_public_path__ + "static/media/icon.error-circle.9cfe06137ebec92a5004cd2a9bc328c5.svg";
export { ForwardRef as ReactComponent };